<template>
  <div :style="customStyle" class="aretv sedna-weather panels-grid">
    <div v-if="current_weather" class="current-weather">
      {{ current_weather.weatherDesc[0].value }}
    </div>
    <WeatherItem
      v-for="(item, index) in entries"
      v-bind:key="index"
      :date="item.date"
      :max="item.maxtempF"
      :min="item.mintempF"
      :desc="item.hourly"
      :code="item.hourly"
    />
    <div class="debug-log">
      <iframe :src="sednaPlaylist" class="sedna-playlist"></iframe>
      <ul>
        <li v-for="(item, idx) in theLog" :key="idx">{{ item }}</li>
      </ul>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import WeatherItem from "./WeatherItem";
import slugify from "slugify";

export default {
  name: "Weather",
  components: { WeatherItem },
  props: ["customStyle", "customBackground", "customColor"],
  data() {
    return {
      isLoading: false,
      entries: [],
      refreshTimer: null,
      backgroundStyle: "transparent",
      current_weather: null,
      playlist: [],
      error: null,
      sedna_ip: "127.0.0.1",
      theLog: [],
      sednaPlaylist: ''
    };
  },
  computed: {
    isEmptyAndLoading() {
      return this.isLoading && this.entries.length === 0;
    }
  },
  methods: {
    getSednaPlaylist() {
      const urlQuery = new URLSearchParams(window.location.search);

      if (urlQuery.get("sedna_ip") !== null) {
        this.sedna_ip = urlQuery.get("sedna_ip");
      }
      axios
        .get(`http://${this.sedna_ip}:17236/services;playlists`)
        .then(result => {this.playlist = result;})
    },
    refreshWeather() {
      const url = "https://api.worldweatheronline.com/premium/v1/weather.ashx",
            urlQuery = new URLSearchParams(window.location.search);

      let currentLocation = "";

      if (urlQuery.get("location") !== null) {
        currentLocation = urlQuery.get("location");
      }
      axios
        .get(url, {
          params: {
            key: "eb498059c2164ed38dc123046191408",
            q: currentLocation,
            num_of_days: "5",
            format: "json",
            show_comments: "no",
            tp: "1"
          }
        })
        .then(result => {
          this.log('Got weather. Will call sedna playlist.');
          this.entries = result.data.data.weather;
          this.current_weather = result.data.data.weather[0].hourly[new Date().getHours()];

          setTimeout(() => {
            if (this.current_weather) {
              const { weatherCode, weatherDesc } = this.current_weather;
              let current_video = slugify(`${weatherCode} ${weatherDesc[0].value}`,{ lower: true });
              this.log(`Calling sedna to play ${current_video} playlist.`);
              this.sednaPlaylist = `http://${this.sedna_ip}:17236/services;execute?command=start%20playlist%20-n%20"${current_video}"`

              axios
                .get(`http://${this.sedna_ip}:17236/services;execute?command=start%20playlist%20-n%20"${current_video}"`)
                .then(result => {
                  this.log(`Sedna response status ${result.status}`);
                  this.log(`Sedna response ${result.data}`);
                  return result;
                }, errResult => {
                  this.log(`Sedna responded with error:`);
                  this.log(errResult);
                  this.log(`Sedna response ${errResult.data}`);
                  this.log(`Response status: ${errResult.request.status}`);
                  Object.keys(errResult).forEach( key => {
                    this.log(`${key}: ${errResult[key]}`);
                  });
                  return result;
                })
            } else { return false; }
          }, 1000);
        });
    },
    log (item) {
      this.theLog.push(item)
      console.log(item)
    }
  },
  created() {
    window.axios = axios
    this.refreshWeather()
    this.getSednaPlaylist()

    this.refreshTimer = setInterval(this.refreshWeather, 60 * 60 * 1000); // refresh news every 30 mins
  }
};
</script>

<style>
  .sedna-weather .current-weather {
    display: none;
    background-color: transparent !important;
    z-index: 1000;
    position: absolute;
    font-size: 240px;
    opacity: 0.06;
    width: 100vw;
    height: 100%;
    top: 10%;
    left: 5%;
    white-space: nowrap;
    text-shadow: 1px 1px 2px red, 0 0 1em blue, 0 0 0.2em blue;
  }
  .debug-log {
    display:none;
    position: absolute;
    top: 0;
    left: 0;
    max-height: 100%;
    width: 100%;
    font-size: 15px;
    overflow-y: scroll;
    background-color: rgba(5,5,5,0.4);
    font-family:Verdana, Geneva, Tahoma, sans-serif
  }
  .debug-log li {
    display:none;
    margin-bottom: 5px;
  }
  .sedna-playlist {
    display:none;
    width: 500px;
    height: 100px;
  }
</style>
